import { useState } from 'react';
import { Send, Loader2 } from 'lucide-react';

export function InputArea({ onSend, disabled = false }: { onSend: (body: string) => Promise<unknown>; disabled?: boolean }) {
  const [body, setBody] = useState('');
  const [sending, setSending] = useState(false);

  const submit = async () => {
    const trimmed = body.trim();
    if (!trimmed || sending || disabled) return;
    setBody('');
    setSending(true);
    try {
      await onSend(trimmed);
    } catch {
      setBody(trimmed);
    } finally {
      setSending(false);
    }
  };

  return (
    <div style={{ display: 'flex', gap: 8, padding: 12, borderTop: '1px solid var(--border)', background: 'var(--surface)' }}>
      <textarea
        aria-label="Message"
        value={body}
        onChange={(e) => setBody(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            void submit();
          }
        }}
        placeholder="Send a message..."
        disabled={disabled || sending}
        rows={2}
        style={{ flex: 1, resize: 'none', background: 'var(--surface2)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 10, padding: '9px 10px', font: 'inherit' }}
      />
      <button className="btn btn-primary" aria-label="Send message" onClick={() => void submit()} disabled={disabled || sending || !body.trim()}>
        {sending ? <Loader2 size={14} className="spin" /> : <Send size={14} />}
      </button>
    </div>
  );
}
